import CustomModal, { CustomModalProps } from '../../base/CustomModal'

export interface GeneratingOverlayWordPdfProps {
	modalStatus: CustomModalProps['modalStatus']
	handleCancel?: CustomModalProps['handleCancel']
	isExplicitCancel?: CustomModalProps['isExplicitClose']
	hideAsposeWarning?: boolean
}

const GeneratingOverlayWordPdf = (
	props: GeneratingOverlayWordPdfProps,
): JSX.Element => {
	const { modalStatus, handleCancel, isExplicitCancel = true } = props

	return (
		<CustomModal
			title="Processing"
			slotAfterTitle={
				<span className="custom-modal__title-loader"></span>
			}
			modalStatus={modalStatus}
			handleCancel={handleCancel}
			isExplicitClose={isExplicitCancel}
			hideConfirmButton
		>
			<p>Please wait a moment while we generate your file.</p>
		</CustomModal>
	)
}

export default GeneratingOverlayWordPdf
